module.exports = __webpack_public_path__ + "public/adminIcons/last30dayusers.svg?854efb7d";